import { render, staticRenderFns } from "./workercald.vue?vue&type=template&id=0b8c2359&scoped=true&"
import script from "./workercald.vue?vue&type=script&lang=js&"
export * from "./workercald.vue?vue&type=script&lang=js&"
import style0 from "./workercald.vue?vue&type=style&index=0&id=0b8c2359&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8c2359",
  null
  
)

export default component.exports